import { Moment } from 'moment';

import { InvoiceItemCategory } from '../types/invoice-item-category';
import { InvoiceItemStatus } from '../types/invoice-item-status';
import { Unit } from '../types/unit';
import { User } from '../user.model';

import { InvoiceLabel } from './invoice-label.model';

/**
 * Model for API InvoiceReplyItemModel Model
 */
export class InvoiceItem {
  /**
   * Auto-generated identifier for the line.
   */
  id: number;

  /**
   * currency for amounts
   */
  currency = 'EUR';

  /**
   * Start date of the periode
   */
  periodStart: Moment;

  /**
   * End date of the periode
   */
  periodEnd: Moment;

  /**
   * One of: commo, grid, tax, misc
   */
  category: InvoiceItemCategory;

  /**
   * Price per unit.
   */
  unitPrice: number;

  /**
   * Quantity.
   */
  quantity: number;

  /**
   * Quantity Unit
   */
  quantityUnit: Unit | string;

  /**
   * Total without VAT
   */
  vatExcludedTotal: number;

  /**
   * VAT rate
   */
  vatRate: number;

  /**
   * VAT identifier
   */
  vatIdentifier: string;

  /**
   * Total price associated to the line.
   */
  total: number;

  /**
   * Semi-formatted and translated label to be printed on invoice.
   */
  label = new InvoiceLabel();

  /**
   * Additionnal comment
   */
  description: string;

  /**
   * Status of the current item
   */
  status: InvoiceItemStatus;

  /**
   * Comment about the status of the current item
   */
  statusComment: string;

  /**
   * User who updates mannually the current item
   */
  manualUpdatedBy: User;

  /**
   * code internal SAP
   */
  internalCode: string;

  /**
   * code external SAP
   */
  externalCode: string;

  /**
   * id of regularization
   */
  regularizationId: string;

  /**
   * price strip source key
   */
  sourceKey: string;

  constructor(attributes: Partial<InvoiceItem> = {}) {
    Object.assign(this, attributes);
  }

  /**
   * Is price unit is a rate
   */
  get isRate(): boolean {
    return this.quantityUnit === this.currency;
  }

  set isRate(value) {
    if (value) {
      this.quantityUnit = this.currency;
    }
  }
}
